import _ from 'lodash/fp';
import React from 'react';

const RecycleContext = React.createContext({});

export { RecycleContext };
